import * as apiUrls from "../api_urls";
import { AxiosClient } from "../axios_client";
import { BEARER } from "../../utils/constants";
const axiosClient = new AxiosClient();

export default class AuthService {
  verify = async (data) => {
    return await axiosClient.post(`${apiUrls.USER_VERIFY}`, data);
  }

  verify2fa = async (data) => {
    return await axiosClient.post(
      apiUrls.USER_VERIFY_2FA,
      { code: data.code },
      { headers: { Authorization: `${BEARER}${data.token2FA}` } }
    );
  }

  login = async (data) => {
    return await axiosClient.post(`${apiUrls.USER_LOGIN}`, data);
  };
}